export default __webpack_public_path__ + "static/media/Download.187c8804.svg";